import { Link } from 'react-router-dom';
import { categories, getFeaturedArticles, getLatestArticles, articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

const faqData = [
  {
    question: '传教士体位适合初学者吗？',
    answer: '是的，传教士体位是所有体位中最适合初学者的一种。它姿势自然、体力要求适中，且面对面交流方便，非常适合刚开始探索亲密关系的伴侣。通过本指南的学习，你可以逐步掌握各种技巧和变式。',
  },
  {
    question: '传教士体位是否意味着体验单一？',
    answer: '完全不是。传教士体位的变式数量在已知的亲密姿势中非常丰富。通过调整角度、节奏、腿部位置等变量，它能够提供数十种截然不同的体验，这也是本网站存在的意义——展示这一经典体位的丰富可能性。',
  },
  {
    question: '如何避免传教士体位中的不适感？',
    answer: '首先，任何不适感都应被认真对待。可以通过调整枕头高度、改变腿部开合角度、降低节奏频率等方式来缓解。如果持续不适，建议咨询专业医生。记住，舒适和安全永远是第一位的。',
  },
  {
    question: '传教士体位的"传教士"名称从何而来？',
    answer: '这个称呼源于20世纪初，西方基督教传教士在太平洋群岛传教时期，向当地原住民推广他们认为"文明"的面对面上位姿势。后来的性学家和人类学家沿用了这一带有历史印记的称呼。我们在"历史与文化"分类中有专门的文章详细解析。',
  },
  {
    question: '本网站的内容是否科学可靠？',
    answer: '本网站内容基于现代性医学、人体解剖学和心理学的研究成果编写。我们力求从科学、客观的角度提供准确信息。但请注意，本网站内容仅为科普性质，不能替代专业医疗建议。',
  },
];

export default function Home() {
  const featuredArticles = getFeaturedArticles();
  const latestArticles = getLatestArticles(6);

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '传教士体位完全指南 - 首页',
    description: '全面解析「传教士体位」的历史起源、基本姿势、进阶技巧与常见变式，帮助伴侣提升亲密关系质量。',
    url: 'https://www.chuanjiaoshi-tiwei.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '传教士体位完全指南',
      url: 'https://www.chuanjiaoshi-tiwei.com/',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <main>
        {}
        <section className="relative h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20intimate%20abstract%20art%20composition%20with%20soft%20flowing%20curves%2C%20cream%20and%20terracotta%20gradients%2C%20gentle%20organic%20shapes%2C%20ambient%20warm%20lighting%2C%20elegant%20minimalist%20aesthetic%2C%20silk%20fabric%20texture%20inspiration%2C%20artistic%20abstract%20photography%2C%20soft%20focus%20dreamy%20atmosphere&width=1800&height=900&seq=hero-homepage&orientation=landscape"
            alt="传教士体位完全指南"
            title="传教士体位完全指南 - 科学视角专业指导"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <div className="max-w-3xl mx-auto">
              <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-500/90 text-background-50 mb-6">
                科学视角 · 专业指导
              </span>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
                传教士体位
                <br />
                <span className="text-accent-400">完全指南</span>
              </h1>
              <p className="text-base md:text-lg text-background-200/90 mb-8 max-w-xl mx-auto leading-relaxed">
                全面解析传教士体位的历史起源、基本姿势、进阶技巧与常见变式，帮助伴侣提升亲密关系质量
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Link
                  to="/category/zonghe-zhinan"
                  className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  开始学习
                </Link>
                <Link
                  to="/about"
                  className="w-full sm:w-auto px-8 py-3 rounded-full border border-background-200/50 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  关于我们
                </Link>
              </div>
            </div>
          </div>
        </section>

        {}
        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                探索内容分类
              </h2>
              <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
                从基础到进阶，系统学习传教士体位的每一个维度
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group p-5 rounded-lg border border-background-200/70 bg-background-50 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {cat.description}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {}
        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                  精选推荐
                </h2>
                <p className="text-foreground-600 text-sm">
                  最受欢迎的传教士体位深度解析
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        {}
        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                  最新文章
                </h2>
                <p className="text-foreground-600 text-sm">
                  持续更新的传教士体位知识库
                </p>
              </div>
              <Link
                to="/category/zonghe-zhinan"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer"
              >
                查看全部
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
            <div className="mt-8 text-center sm:hidden">
              <Link
                to="/category/zonghe-zhinan"
                className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer"
              >
                查看全部文章
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </div>
        </section>

        {}
        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                常见问题
              </h2>
              <p className="text-foreground-600 text-sm">
                关于传教士体位，你最关心的问题都在这里
              </p>
            </div>
            <div className="space-y-4">
              {faqData.map((faq, index) => (
                <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                  <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                    <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                      {faq.question}
                    </h4>
                    <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-45 transition-transform duration-200">
                      <i className="ri-add-line"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {}
        <section className="relative w-full px-4 md:px-6 py-14 md:py-20 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20soft%20curves%2C%20terracotta%20and%20cream%20blend%2C%20elegant%20flowing%20textures%2C%20minimalist%20art%20composition%2C%20gentle%20organic%20shapes%2C%20peaceful%20atmosphere%2C%20high%20end%20interior%20design%20aesthetic&width=1800&height=600&seq=cta-homepage&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/35"></div>
          <div className="relative z-10 max-w-3xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
              开始你的学习之旅
            </h2>
            <p className="text-background-200/90 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
              从基础姿势到进阶变式，系统掌握传教士体位的每一个细节。科学视角，专业指导，让你的亲密关系更进一步。
            </p>
            <Link
              to="/category/zonghe-zhinan"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-accent-500 text-background-50 font-medium text-sm hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即探索
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </section>
      </main>
    </>
  );
}